import { Variants } from 'framer-motion'

export const ERROR_ANIMATION_VARIANTS: Variants = {
  visible: {
    opacity: 1,
    translateY: '-100%',
  },
  hidden: {
    opacity: 0,
    translateY: '-50%',
  },
}
